import ToastList from '../../components/notifications/toast_list.vue'
import UserAvatar from '../../components/user_avatar.vue'

export const shellComponents = {
  'toast-list': ToastList,
  'user-avatar': UserAvatar,
}
